import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import {
	BtnExtComponent,
	SpinOrContent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"

@Component({
	selector: "app-meeting-requests",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		GenButtonGroupComponent,
		TableWrapComponent,
		DateFormatPipe,
		LangValPipe,
		BtnExtComponent,
		ModalWrapComponent,
		InsertPatientFormComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-spin-or-content [isSpin]="isSpin">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="status"
				optionsListName="mr_status_opts"
				(changeEvent)="filterRows()"
			/>

			<app-table-wrap
				fieldsStr="created_at,name,date,time,email,phone,remarks:30,status,actions"
			>
				@for (row of displayRows; track row) {
					<tr>
						<td>{{ row.created_at | dateFormat }}</td>
						<td>{{ row.name }}</td>
						<td>{{ row.date | dateFormat }}</td>
						<td>{{ row.time }}</td>
						@for (field of ["email", "phone", "remarks"]; track field) {
							<td>{{ row[field] || "" }}</td>
						}
						<td>{{ row.status | langVal }}</td>
						<td>
							@if (row.status != "declined") {
								@if (row?.date) {
									<button
										class="btn btn-primary"
										(click)="schedMeeting(row)"
										titleLang="confirm_meeting"
									>
										{{ "confirm_meeting" | langVal }}
									</button>
								}
								@if (row.status == "new" || row.status == "checking") {
									<app-btn-ext
										text="to_insert_patient_form"
										(clickEv)="openNewPatient(row)"
									/>
								}
								<app-btn-ext
									text="deactivate_meeting_request"
									(clickEv)="deactivateMeetingRequest(row)"
									[isSpin]="row.deactivateSpin"
								/>
							}
						</td>
					</tr>
				}
			</app-table-wrap>
		</app-spin-or-content>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				title="insert_patient_form"
				modalWrapperClass="modal-800"
			>
				<app-insert-patient-form
					(onClose)="modalProps = null"
					hasUpdate
					[meeting_request]="modalProps.meeting_request"
				/>
			</app-modal-wrap>
		}
	`,
})
export class MeetingRequestsComponent extends Modalable {
	modalProps: any = null
	rows: any[] = []
	displayRows: any[] = []
	status: string = "0"
	isSpin: boolean = false

	async ngOnInit() {
		this.isSpin = true
		const res = await this.apiService.post("get_meeting_reqeusts")
		this.isSpin = false
		this.rows = res.rows
		this.filterRows()
		this.store.removeDecArr(this.rows)
	}
	filterRows() {
		if (this.status == "0") {
			this.displayRows = this.rows
		} else {
			this.displayRows = this.rows.filter((row) => row.status == this.status)
		}
	}

	async deactivateMeetingRequest(row: any) {
		row.deactivateSpin = true
		const res: any = await this.store.deactivate_meeting_request(row.id)
		row.deactivateSpin = false
		if (res?.success) {
			row.status = "declined"
			this.filterRows()
		}
		this.store.calendarChangesSubj.next(true)
		//this.rows=this.rows.filter(r=>r.id!=row.id);
	}
	async schedMeeting(row: any) {
		//close tasks modal, go to calendar in the week of MR date, open add-meeting modal with the MR date/time
		this.router.navigateByUrl("/calendar")
		// this.onClose.emit();
		await this.store.timeout(200)
		this.store.calendarOpenMeetingSubject.next(row)
		this.onClose.emit(true)
	}

	async openNewPatient(meeting_request: any) {
		this.modalProps = {
			name: "insert-patient-form",
			meeting_request: this.store.removeDecItem(meeting_request),
		}
	}
}
